import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';
import UserListPage from '@features/users/UserListPage';

export const Route = createFileRoute('/t/users/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'effectiveFrom', sortDir: 'desc', tab: 'ALL' }),
  component: TenantUsersPage,
});

function TenantUsersPage() {
  const searchParams = Route.useSearch();
  return <UserListPage routeTo="/t/users" searchParams={searchParams} />;
}
